import { useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "../styles/menuAddSearchList.module.css";
import { MenuAddSearchListItem } from "./menuAddSearchListItem";

import { isBrand, isProduct } from "../typeHelpers/typeCheck";

export const MenuAddSearchList = ({ results, handleAddMenuItem }: { results: any[]; handleAddMenuItem: Function }) => {
  const { products } = useSelector((state: any) => state.product);

  useEffect(() => {
    // check if any of the products.name === results.name, if so, pass in a new prop to menuAddSearchListItem to disable the button
    //console.log("products", products);
  }, [products]);

  const checkIfOwned = (item: Brand | Product) => {
    if (isBrand(item)) {
      //console.log("item is a bran", item);
      return false;
    } else if (isProduct(item)) {
      return products.some((product: Product) => product.name === item.name);
    } else {
      return false;
    }
  };

  const getResultType = (item: Brand | Product) => {
    if (isBrand(item)) {
      return "brand";
    } else if (isProduct(item)) {
      return "product";
    } else {
      return undefined;
    }
  };

  return (
    <div className={styles.wrapper}>
      {results.map((result: Brand | Product, index: number) => {
        return (
          <MenuAddSearchListItem
            handleAddMenuItem={handleAddMenuItem}
            isOwned={checkIfOwned(result)}
            key={index}
            type={getResultType(result)}
            item={result}
          />
        );
      })}
    </div>
  );
};
